import React, { PropTypes } from 'react';
import { PageHeader, ListGroup, ListGroupItem, Col, Button, Alert } from 'react-bootstrap';
import _ from 'lodash';

import StatisticsComponent from './components/Statistics';

import './AnalyticsComponent.scss';
import './virtualized.css';

export default class AnalyticsComponent extends React.Component {
  constructor(props, context) {
    super(props, context);

  }

  render() {
    return (
      <StatisticsComponent/>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/settings/AnalyticsComponent.js